import { TableRowEditor } from '../sharedModules/designSystem/mu-table/mu-table.component';

export type ActionValue<Type> = string | Type | TableRowEditor<Type>;

export type ActionChain<ActionType, Type> = (type: ActionType, value?: ActionValue<Type>) => void;

export type ActionListener<ActionType, Type> = (type: ActionType, value: ActionValue<Type>, chain: ActionChain<ActionType, Type>) => void;

export class Actions<ActionType, Type> {
  private listeners = new Map<ActionType, ActionListener<ActionType, Type>[]>();
  private chainFn: ActionChain<ActionType, Type>;

  constructor() {
    this.chainFn = this.chain.bind(this);
  }

  /**
   * emit an action value
   */
  emit(action: ActionType, value: ActionValue<Type>) {
    const listeners = this.listeners.get(action);
    if (listeners) {
      listeners.forEach(listener => listener(action, value, this.chainFn));
    }
  }

  /**
   * chain actions
   */
  private chain(type: ActionType, value: ActionValue<Type>) {
    this.emit(type, value);
  }

  /**
   * register to ract over an action
   */
  on(action: ActionType, listener: (type: ActionType, value: ActionValue<Type>, chain: ActionChain<ActionType, Type>) => void) {
    let listeners = this.listeners.get(action);
    if (!listeners) {
      listeners = [];
      this.listeners.set(action, listeners);
    }
    listeners.push(listener);
  }
}
